export default __webpack_public_path__ + "static/media/3991.df053729.png";